import React, { useState, useEffect } from 'react';
import { getFAQs } from '../services/api';
import { Loader2 } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const data = await getFAQs();
        setFaqs(data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load FAQs');
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  if (loading) {
    return (
      <section id="faq" className="section-spacing bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <Loader2 className="w-12 h-12 animate-spin mx-auto accent-gold" />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="faq" className="section-spacing bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-destructive">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section id="faq" className="section-spacing bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-serif font-semibold text-foreground mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Everything you need to know about our products and services
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={`item-${faq.id}`}
              className="bg-blush rounded-xl px-6 border-0 shadow-sm hover:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left font-sans font-semibold text-foreground hover:text-primary py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
